// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__3wGEg","item-title":"Item_item-title__3CMwz","item-content":"Item_item-content__1jZbR"};